module.exports = __webpack_public_path__ + "static/media/ai&machine_learning.4f9eb00d.svg";